/**
 * §P.5 · El marco de «Grados»: los sistemas y los exámenes.
 *
 * Dos pestañas que son dos trabajos distintos con el mismo tema: **la escalera** —que
 * se define una vez y se toca cada dos años— y **los exámenes** —que se convocan dos
 * o tres veces al curso—. Antes solo estaba la primera.
 *
 * Los sistemas van primero porque sin escalera no hay a qué examinarse, y porque es
 * lo que un club nuevo tiene que hacer antes de nada.
 *
 * Sin guardián de rol: las rutas de debajo son `own`, `adm` y `coa`, y quien decide
 * que alguien está listo para el amarillo es quien le da clase.
 */
import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { VISTAS_DE_GRADOS } from '@/club/secciones';

export function MarcoDeGrados() {
  const camino = useRouterState({ select: (s) => s.location.pathname });

  return (
    <>
      <nav className="pestañas" aria-label="Pantallas de grados">
        {VISTAS_DE_GRADOS.map((v) => {
          const destino = `/grados/${v.id}`;
          return (
            <Link
              key={v.id}
              to={destino}
              className={
                camino.startsWith(destino) ? 'pestaña-activa' : 'btn-plano'
              }
            >
              {v.etiqueta}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </>
  );
}
